import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default class GalleryLink extends React.Component {
    static propTypes = {
        href: PropTypes.string,
        onEnter: PropTypes.func,
        onEnterAsync: PropTypes.func,
        children: PropTypes.any
    };
    static defaultProps = {
        href: ''
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return this.props.href !== nextProps.href || this.props.onEnter !== nextProps.onEnterPhoto || this.props.onEnterAsync !== nextProps.onEnterPhotoAsync;
    }

    render() {
        if (this.props.onEnter) {
            return (
                <Link className="component-gallery-link" onClick={this.props.onEnter}>
                    {this.props.children}
                </Link>
            );
        } else if (this.props.onEnterAsync) {
            return (
                <Link className="component-gallery-link" to={this.props.href} onClick={this.props.onEnterAsync}>
                    {this.props.children}
                </Link>
            );
        } else {
            return (
                <Link className="component-gallery-link" to={this.props.href}>
                    {this.props.children}
                </Link>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryLink/index.js